import api from "../../../api/sphinxAPI";

/** =========== MASTER DASHBORD =========== **/
export const getAllSnapshots = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/getAllSnapshots`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response.data.snapshots;
};

export const getAllPastSessions = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/getAllPastSessions`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response.data.pastsessions;
};

export const newDataSnapshot = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newDataSnapshot`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response.data.snapshot;
};

export const saveViewConfig = async function(data) {
  if (!data.userID || !data.allowedRows) {
    return console.log("Required information missing for request");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/saveViewConfig`,
      data,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response.view;
};

export const updateOneConfig = async function(data) {
  if (!data.userID || !data.allowedRows) {
    return console.log("Required information missing for request");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/updateOneConfig`,
      data,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response.data.view.allowedRows;
};

export const getViewConfig = async function(userID) {
  if (!userID) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/getViewConfig`,
      params: { userID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response && response.data && response.data.view && response.data.view.allowedRows ? response.data.view.allowedRows : null;
};

export const deleteDataSnapshot = async function(snapshotID) {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteDataSnapshot`,
      data: { snapshotID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

const DataMaster = {
  getAllSnapshots,
  getAllPastSessions,
  newDataSnapshot,
  saveViewConfig,
  getViewConfig,
  updateOneConfig,
  deleteDataSnapshot,
};

export default DataMaster;
